import { render, staticRenderFns } from "./YearsPage.vue?vue&type=template&id=6fa04e18&scoped=true"
import script from "./YearsPage.vue?vue&type=script&lang=js"
export * from "./YearsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa04e18",
  null
  
)

export default component.exports